/*
* @desc 词云图
*/
import 'echarts-wordcloud';
import React, { PureComponent } from 'react';
import extend from './utils/extend';
import { tooltipStyles, colors } from './config/config';
import EchartBase from './base/EchartBase';

class BBDWordCloud extends PureComponent {
    constructor(props) {
        super(props);
    }
    setOption(param){

        const option = {
            color: colors.color.slice(),
            title: {
                text: '',
                padding: [10, 0, 0, 10],
                textStyle: {
                    fontSize: 16,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei'
                }
            },
            tooltip: {
                position: 'top',
                padding: [10, 10, 10, 10],
                ...tooltipStyles
            },
            series: [{
                name: '',
                type: 'wordCloud',
                shape: 'circle',
                rotationRange: [0, 0],
                sizeRange: [18, 48],
                gridSize: 8,
                drawOutOfBound: false,
                textStyle: {
                    normal: {
                        fontWeight: 'bold'
                    }
                },
                data: []
            }]
        };
        let op = extend(true, {}, option, param);
        return op;
    }
    render() {
        return (
            <EchartBase onEvents={this.props.onEvents} option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDWordCloud;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDWordCloud.jsx